import * as Firebase from "firebase/app";
import "firebase/functions";
import "firebase/firestore";
import "firebase/auth";
import "firebase/remote-config";
import "firebase/firestore";

let config = {
  apiKey: "AIzaSyAepQ4-iabBUTRg1o8FAdfLVOsVYHHgsBo",
  authDomain: "docket-71286.firebaseapp.com",
  databaseURL: "https://docket-71286.firebaseio.com",
  projectId: "docket-71286",
  storageBucket: "docket-71286.appspot.com",
  messagingSenderId: "279730137811",
  appId: "1:279730137811:web:7954707f8f9b616e388226",
  measurementId: "G-HQL96DPL8W",
};

function initFirebase() {
  Firebase.initializeApp(config);
  return new Promise((resolve, reject) => {
    Firebase.firestore()
      .enablePersistence()
      .then(resolve)
      .catch((err) => {
        console.error(err);
        if (err.code === "failed-precondition") {
          reject(err);
          // Multiple tabs open, persistence can only be
          // enabled in one tab at a a time.
        } else if (err.code === "unimplemented") {
          reject(err);
          // The current browser does not support all of
          // the features required to enable persistence
        }
      });
  });
}

export { Firebase, initFirebase };
